module.exports = __webpack_public_path__ + "img/basket2.f50c77cd.svg";